var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLove(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 50,
    fill: "none",
    viewBox: "0 0 51 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M27.9626 44.4449C40.0388 33.9892 47.0002 27.962 47.0002 19.4638C47.0002 13.9231 44.1214 9.03738 39.5637 7.00391C46.3494 7.17698 51.0002 12.9814 51.0002 19.8376C51.0002 28.7086 42.997 35.6833 29.3149 47.6072C28.7906 48.064 28.2581 48.5282 27.7173 48.9999C26.8485 48.242 26.0872 47.4552 25.4233 46.646C26.2931 45.8903 27.1397 45.1573 27.9626 44.4449Z",
    clipRule: "evenodd",
    opacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M45 19.3994C45 28.161 36.739 34.0267 22.7079 46.188C9.36467 34.6232 0 28.5585 0 19.3994C0 12.7781 4.58992 7.18799 11.251 7.18799C19.7998 7.18799 22.5 16.9375 22.5 16.9375C22.5 16.9375 25.2002 7.18799 33.751 7.18799C40.4101 7.18799 45 12.7781 45 19.3994Z",
    clipRule: "evenodd"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLove);
export default __webpack_public_path__ + "static/media/love.217ef8bd2137f095640f1ac56c46569d.svg";
export { ForwardRef as ReactComponent };